export const defaultDisabled = {
  loja: false,
  parceiro: false,
  produto: true,
  ajuste: false,
  qtd: false,
  un: false,
  emb: false,
  val_custo: false,
  docto: false,
};

export const productDefault = {
  cod_gtin_principal: null,
  cod_produto: null,
  des_produto: null,
  des_reduzida: null,
  qtd_total_estoque: null,
  val_preco: null,
  val_custo_rep: null,
  cod_loja: null,
  des_unidade_compra: null,
  flg_ipv: null,
};

export const defaultData = {
  busca_parceiro: { label: undefined, value: undefined },
  busca_produto: { label: undefined, value: undefined },
  cod_tipo_ajuste: { label: undefined, value: undefined },
  qtd_ajuste: null,
  des_un: null,
  des_emb: null,
  val_custo_unit: null,
  num_docto: null,
};
